import { useState } from 'react';
import { inject } from '@/diagnostic/injections.ts';
import { DIAGNOSTICS } from '@/diagnostic/DiagnosticKeys.ts';
import type { DiagnosticId } from '@/diagnostic/domain/DiagnosticId.ts';
import type { DiagnosticReport } from '@/diagnostic/domain/DiagnosticReport.ts';
import { Optional } from '@/generic/functional';
import { useOptional } from '@/generic/react-tools';
import { DiagnosticReportModalComponent } from '@/diagnostic/primary/DiagnosticReportModalComponent.tsx';

export const useDiagnosticReportModal = () => {
  const [open, setOpen] = useState(false);
  const [report, setReport] = useState<Optional<DiagnosticReport>>(Optional.empty());

  const openReport = (id: DiagnosticId) => {
    inject(DIAGNOSTICS)
      .getReport(id)
      .then((diagnosticReport) => {
        setReport(Optional.of(diagnosticReport));
        setOpen(true);
      });
  };

  const closeReport = () => setOpen(false);

  const modal = useOptional({
    optional: report,
    onValuated: (value) => (
      <DiagnosticReportModalComponent open={open} onClose={closeReport} report={value} />
    ),
  });

  return { openReport, modal };
};
